import React from 'react';

export default function Contact() {
  // Social media and platform links
  const INSTAGRAM_URL = "https://www.instagram.com/shabaaztrading/";
  const YOUTUBE_URL = "https://www.youtube.com/channel/UC92IGBofPfsgbu86ERVlAVQ";
  const WHATSAPP_NUMBER = "919016235501";
  const SECONDARY_WHATSAPP = "917861862566";
  
  // Google Maps location URL
  const MAPS_LOCATION_URL = "https://maps.app.goo.gl/627TDwQQSTChznqW7";
  
  // EXACT COORDINATES for the location
  const LATITUDE = "21.780033052691966";
  const LONGITUDE = "72.12943262863345";
  
  // FIXED: Simple working embed URL with red pin marker
  // Using the standard format that Google Maps uses to show a red pin
  const MAPS_EMBED_SRC = `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${LATITUDE},${LONGITUDE}&zoom=17&maptype=roadmap`;

  const openWhatsApp = (phoneNumber, message) => {
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handlePrimaryWhatsApp = () => {
    const message = `Hello Shabaaz Trading Co., I would like to inquire about your products and services.`;
    openWhatsApp(WHATSAPP_NUMBER, message);
  };

  const handleSecondaryWhatsApp = () => {
    const message = `Hello Shabaaz Trading Co., I would like to get more information.`;
    openWhatsApp(SECONDARY_WHATSAPP, message);
  };

  const openGoogleMaps = () => {
    window.open(MAPS_LOCATION_URL, '_blank');
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '60px 20px', fontFamily: '"Inter", "Segoe UI", sans-serif' }}>
      <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#0c4a6e', marginBottom: '40px', textAlign: 'center' }}>Contact Our Global Desk</h2>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '40px' }}>
        {/* Contact Info Panel */}
        <div style={{ backgroundColor: '#0c4a6e', color: '#ffffff', padding: '40px', borderRadius: '12px', boxShadow: '0 10px 25px rgba(12, 74, 110, 0.15)' }}>
          <h3 style={{ margin: '0 0 24px 0', fontSize: '1.5rem', fontWeight: '700' }}>SHABAAZ TRADING CO.</h3>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div>
              <span style={{ display: 'block', fontSize: '0.8rem', textTransform: 'uppercase', color: '#38bdf8', fontWeight: '700' }}>Management Office</span>
              <p style={{ margin: '4px 0 0 0', fontSize: '1rem', lineHeight: '1.5' }}>
                <strong>Founder:</strong> Salim Lakhani <br />
                <strong>Co Founder:</strong> Javed Lakhani<br />
                <strong>CEO / Owner:</strong> Ayan Salim Lakhani <br />
                <strong>Manager:</strong> Shabaaz Javed Lakhani
              </p>
            </div>
            <div>
              <span style={{ display: 'block', fontSize: '0.8rem', textTransform: 'uppercase', color: '#38bdf8', fontWeight: '700' }}>GST Identification</span>
              <p style={{ margin: '4px 0 0 0', fontSize: '1rem' }}>24ABUPL6740K1Z4</p>
            </div>
            <div>
              <span style={{ display: 'block', fontSize: '0.8rem', textTransform: 'uppercase', color: '#38bdf8', fontWeight: '700' }}>Email Network</span>
              <p style={{ margin: '4px 0 0 0', fontSize: '1rem', lineHeight: '1.4' }}>
                shabaaztradingco04@gmail.com <br />
                lakhanishabaazlakhani@gmail.com
              </p>
            </div>
            <div>
              <span style={{ display: 'block', fontSize: '0.8rem', textTransform: 'uppercase', color: '#38bdf8', fontWeight: '700' }}>Hotline / WhatsApp / Call</span>
              <p style={{ margin: '4px 0 0 0', fontSize: '1rem', lineHeight: '1.4' }}>
                +91 9016235501 (Ayan Lakhani) <br />
                +91 7861862566 (Shabaaz Lakhani)<br />
                +91 9825208692 (Javed Lakhani)<br />
                +91 9426917780 (Salim Lakhani)
              </p>
            </div>
          </div>
        </div>

        {/* Operational Scope Panel */}
        <div style={{ backgroundColor: '#ffffff', padding: '40px', borderRadius: '12px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: '1.5rem', fontWeight: '700', color: '#0c4a6e' }}>Business Scope & RFQ</h3>
          <p style={{ color: '#475569', lineHeight: '1.6', margin: '0 0 20px 0' }}>
            Specializing globally in <strong>All types of marine machinery</strong> and heavy deployment hardware pipelines.
          </p>
          
          <div style={{ padding: '20px', backgroundColor: '#f8fafc', borderRadius: '8px', borderLeft: '4px solid #0284c7', marginBottom: '20px' }}>
            <span style={{ fontWeight: '700', color: '#0f172a', display: 'block', fontSize: '0.9rem', marginBottom: '8px' }}>Procurement Specializations:</span>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.85rem', color: '#475569', lineHeight: '1.6' }}>
              <li>All types of Marine Pumps (West water, Submersible, Monoblock, Oil, S.S pumps)</li>
              <li>All types of Heavy Motors & Gear Motors</li>
              <li>Comprehensive Vessel Parts & Ship Items</li>
            </ul>
          </div>

          <div style={{ padding: '16px', backgroundColor: '#f0f9ff', borderRadius: '8px', borderLeft: '4px solid #38bdf8' }}>
            <span style={{ fontWeight: '700', color: '#0369a1', display: 'block', fontSize: '0.9rem' }}>Quick Support Status</span>
            <span style={{ fontSize: '0.85rem', color: '#0284c7' }}>Average response window for RFQ & custom pricing configurations: &lt; 2 Hours</span>
          </div>

          {/* Social Media & Platform Links */}
          <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e2e8f0' }}>
            <span style={{ fontWeight: '700', color: '#0c4a6e', display: 'block', fontSize: '0.9rem', marginBottom: '12px' }}>Connect With Us On:</span>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <a 
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  color: '#475569',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: '500',
                  transition: 'color 0.2s ease',
                  padding: '6px 12px',
                  backgroundColor: '#f1f5f9',
                  borderRadius: '30px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#E4405F'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#475569'}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#E4405F' }}>
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM12 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
                Instagram
              </a>
              <a 
                href={YOUTUBE_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  color: '#475569',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: '500',
                  transition: 'color 0.2s ease',
                  padding: '6px 12px',
                  backgroundColor: '#f1f5f9',
                  borderRadius: '30px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#FF0000'}
                onMouseLeave={(e) => e.currentTarget.style.color = '#475569'}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ color: '#FF0000' }}>
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.376.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.376-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
                YouTube
              </a>
              <button 
                onClick={handlePrimaryWhatsApp}
                style={{ 
                  display: 'inline-flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  color: '#475569',
                  background: '#f1f5f9',
                  border: 'none',
                  fontSize: '0.85rem',
                  fontWeight: '500',
                  cursor: 'pointer',
                  padding: '6px 12px',
                  borderRadius: '30px',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => { e.currentTarget.style.color = '#25D366'; e.currentTarget.style.backgroundColor = '#dcfce7'; }}
                onMouseLeave={(e) => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.backgroundColor = '#f1f5f9'; }}
              >
                💬 WhatsApp
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Google Maps Location Section - NOW WITH RED PIN */}
      <div style={{ marginTop: '60px' }}>
        <h3 style={{ fontSize: '1.8rem', fontWeight: '700', color: '#0c4a6e', marginBottom: '20px', textAlign: 'center' }}>Our Location</h3>
        
        <div style={{ 
          backgroundColor: '#ffffff', 
          borderRadius: '12px', 
          overflow: 'hidden',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e2e8f0'
        }}>
          {/* Interactive Map Embed - RED PIN WILL SHOW AT EXACT COORDINATES */}
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
            <iframe
              src={MAPS_EMBED_SRC}
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Shabaaz Trading Co. Location - Bhavnagar, Gujarat"
            ></iframe>
          </div>
          
          {/* Location Info Bar */}
          <div style={{ 
            padding: '20px 24px', 
            backgroundColor: '#f8fafc',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '16px',
            borderTop: '1px solid #e2e8f0'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#0c4a6e">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              <div>
                <div style={{ fontWeight: '700', color: '#0f172a', fontSize: '1rem' }}>Shabaaz Trading Co.</div>
                <div style={{ color: '#475569', fontSize: '0.85rem' }}>Sharma Rolling Compound, Plot No.73, Madhiya Rd, Kumbharwada, Bhavnagar, Gujarat 364001</div>
              </div>
            </div>
            
            <button
              onClick={openGoogleMaps}
              style={{
                backgroundColor: '#0c4a6e',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '30px',
                fontSize: '0.9rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0284c7'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#0c4a6e'}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
              </svg>
              Open in Google Maps
            </button>
          </div>
        </div>
        
        {/* Additional Location Info with Exact Coordinates Display */}
        <div style={{ 
          marginTop: '20px', 
          padding: '16px', 
          backgroundColor: '#f0f9ff', 
          borderRadius: '8px', 
          textAlign: 'center',
          borderLeft: '4px solid #0284c7',
          borderRight: '4px solid #0284c7'
        }}>
          <p style={{ margin: 0, color: '#0369a1', fontSize: '0.9rem' }}>
            📍 <strong>Visit our office at:</strong> Sharma Rolling Compound, Plot No.73, Madhiya Rd, Kumbharwada, Bhavnagar, Gujarat 364001
          </p>
          <p style={{ margin: '8px 0 0 0', color: '#e74c3c', fontSize: '0.85rem', fontWeight: '600' }}>
            🔴 <strong>Red pin location:</strong> {LATITUDE}, {LONGITUDE}
          </p>
          <p style={{ margin: '4px 0 0 0', color: '#0369a1', fontSize: '0.85rem' }}>
            For inquiries, procurement consultations, and business meetings. We recommend scheduling an appointment prior to your visit.
          </p>
        </div>
      </div>
    </div>
  );
}